(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4357],{

/***/ 8426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    fill: "none",
    height: "1em",
    viewBox: "0 0 40 40",
    width: "1em"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      stroke: "#fff",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
        cx: 20,
        cy: 20,
        r: 19.431,
        strokeOpacity: 0.15,
        strokeWidth: 1.137,
        transform: "rotate(180 20 20)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M18.235 14.117L24.118 20l-5.883 5.883",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.961
      })]
    })
  }));
};

var MemoArrowRight = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ArrowRight);
/* harmony default export */ __webpack_exports__["Z"] = (MemoArrowRight);

/***/ }),

/***/ 60151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ PodcastList; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93646);
/* harmony import */ var _podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _icons_Logo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23583);
/* harmony import */ var app_utils_array__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91942);
/* harmony import */ var _icons_ArrowRight__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8426);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25934);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80621);
/* harmony import */ var app_utils_scroll__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21278);
/* harmony import */ var app_utils_is_mobile_resolution__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26089);
/* harmony import */ var app_context_features_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10833);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);















var PodcastList = function PodcastList(_ref) {
  var items = _ref.items,
      label = _ref.label,
      loading = _ref.loading,
      className = _ref.className,
      itemClassName = _ref.itemClassName,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 1 : _ref$rows,
      _ref$fetchNextPage = _ref.fetchNextPage,
      fetchNextPage = _ref$fetchNextPage === void 0 ? function () {} : _ref$fetchNextPage;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
    return (0,uuid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  }),
      scrollSyncId = _useState[0];

  var podcastListRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var elementsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
  var loadMoreTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useFeaturesContext = (0,app_context_features_context__WEBPACK_IMPORTED_MODULE_4__/* .useFeaturesContext */ .Pp)(),
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled;

  var intersection = (0,react_use__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(loadMoreTriggerRef, {
    rootMargin: "0px",
    threshold: 1
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (intersection !== null && intersection !== void 0 && intersection.isIntersecting) {
      fetchNextPage();
    }
  }, [intersection]);

  var getRowCount = function getRowCount(items, rows) {
    //@TODO: change the logic
    if (rows === 3) {
      if (items.length > 10) {
        return 3;
      }

      return items.length > 5 ? 2 : 1;
    }

    return 1;
  };

  var isMobile = (0,app_utils_is_mobile_resolution__WEBPACK_IMPORTED_MODULE_9__/* .useIsMobileResolution */ .zO)();
  var itemRows = (0,app_utils_array__WEBPACK_IMPORTED_MODULE_10__/* .splitToChunks */ .T)(items, getRowCount(items, rows));

  var onForward = function onForward() {
    var _podcastListRef$curre;

    (_podcastListRef$curre = podcastListRef.current) === null || _podcastListRef$curre === void 0 ? void 0 : _podcastListRef$curre.scrollTo({
      left: (0,app_utils_scroll__WEBPACK_IMPORTED_MODULE_11__/* .calculatePodcastScroll */ ._7)(podcastListRef.current.scrollLeft, false, isMobile),
      behavior: "smooth"
    });
  };

  var onBackward = function onBackward() {
    var _podcastListRef$curre2;

    (_podcastListRef$curre2 = podcastListRef.current) === null || _podcastListRef$curre2 === void 0 ? void 0 : _podcastListRef$curre2.scrollTo({
      left: (0,app_utils_scroll__WEBPACK_IMPORTED_MODULE_11__/* .calculatePodcastScroll */ ._7)(podcastListRef.current.scrollLeft, true, isMobile),
      behavior: "smooth"
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper), className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().header),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h2", {
        children: label
      }), !arrowNavigationEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().buttons),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow), (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow_back)),
          onClick: function onClick() {
            return onBackward();
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_ArrowRight__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
          className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow),
          onClick: function onClick() {
            return onForward();
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_ArrowRight__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast_list),
      ref: podcastListRef,
      children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().row),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast), (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast), (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast), (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast), (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast), (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast), (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        })]
      }) : itemRows.map(function (row, rowIndex) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().row),
          "data-navigate-row": true,
          "data-navigate-scrollable": true,
          "data-navigate-scrollable-parent": true,
          "data-sync-scroll-position": scrollSyncId,
          children: [row.map(function (podcast, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              href: "/".concat(podcast.permalink),
              passHref: true,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
                "data-navigate-item": true,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast), itemClassName),
                ref: function ref(e) {
                  if (e) {
                    elementsRef.current[index] = e;
                  }
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                  className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast_img)),
                  children: podcast !== null && podcast !== void 0 && podcast.logo || podcast !== null && podcast !== void 0 && podcast.smallLogo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().cover),
                    src: (podcast === null || podcast === void 0 ? void 0 : podcast.logo) || (podcast === null || podcast === void 0 ? void 0 : podcast.smallLogo) || "",
                    width: isMobile ? 68 : 110,
                    height: isMobile ? 68 : 110,
                    layout: "fixed",
                    objectFit: "cover",
                    alt: podcast.name,
                    unoptimized: true
                  }, "podcast-".concat(index)) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().cover), (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().no_image)),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_Logo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                  className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast_details),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h3", {
                    className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast_name),
                    children: podcast.name
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                    className: (_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().podcast_description),
                    children: podcast.description
                  })]
                })]
              })
            }, "podcast-item-".concat(podcast.permalink, "-").concat(rowIndex, "-").concat(index));
          }), rowIndex === 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            ref: loadMoreTriggerRef
          })]
        }, "podcasts-row-".concat(rowIndex));
      })
    })]
  });
};

/***/ }),

/***/ 79666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ StationsList; }
/* harmony export */ });
/* harmony import */ var app_store_slices_player__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22564);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4062);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var _stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98215);
/* harmony import */ var _stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var app_utils_array__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91942);
/* harmony import */ var _icons_ArrowRight__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8426);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25934);
/* harmony import */ var app_context_player_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48346);
/* harmony import */ var _stations_row_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99845);
/* harmony import */ var app_utils_scroll__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21278);
/* harmony import */ var app_utils_is_mobile_resolution__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26089);
/* harmony import */ var app_context_features_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10833);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);















var StationsList = function StationsList(_ref) {
  var items = _ref.items,
      label = _ref.label,
      loading = _ref.loading,
      showDetailsOnClick = _ref.showDetailsOnClick,
      wrapped = _ref.wrapped,
      className = _ref.className,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 1 : _ref$rows,
      _ref$showStationNames = _ref.showStationNames,
      showStationNames = _ref$showStationNames === void 0 ? false : _ref$showStationNames,
      _ref$fetchNextPage = _ref.fetchNextPage,
      fetchNextPage = _ref$fetchNextPage === void 0 ? function () {} : _ref$fetchNextPage;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(function () {
    return (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
  }),
      scrollSyncId = _useState[0];

  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_1__/* .useAppDispatch */ .TL)();

  var _useFeaturesContext = (0,app_context_features_context__WEBPACK_IMPORTED_MODULE_6__/* .useFeaturesContext */ .Pp)(),
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled;

  var _usePlayerContext = (0,app_context_player_context__WEBPACK_IMPORTED_MODULE_4__/* .usePlayerContext */ .gD)(),
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled,
      setFullscreenPlayerInitialyOpen = _usePlayerContext.setFullscreenPlayerInitialyOpen;

  var radioListRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
  var itemRows = (0,app_utils_array__WEBPACK_IMPORTED_MODULE_9__/* .splitToChunks */ .T)(items, items.length / rows > 7 ? rows : 1);

  var handleOnClick = function handleOnClick(radioStation, stationIndex) {
    setFullscreenPlayerInitialyOpen(true);
    setPlayerEnabled(true);
    dispatch(app_store_slices_player__WEBPACK_IMPORTED_MODULE_0__/* .playerActions.selectTrack */ .i9.selectTrack({
      category: radioStation,
      podcast: null
    }));
    dispatch(app_store_slices_player__WEBPACK_IMPORTED_MODULE_0__/* .playerActions.setRadioQueue */ .i9.setRadioQueue({
      items: items,
      activeIndex: items.indexOf(radioStation)
    }));
  };

  var isMobile = (0,app_utils_is_mobile_resolution__WEBPACK_IMPORTED_MODULE_10__/* .useIsMobileResolution */ .zO)();

  var onForward = function onForward() {
    var _radioListRef$current;

    (_radioListRef$current = radioListRef.current) === null || _radioListRef$current === void 0 ? void 0 : _radioListRef$current.scrollTo({
      left: (0,app_utils_scroll__WEBPACK_IMPORTED_MODULE_11__/* .calculateRadioScroll */ .R$)(radioListRef.current.scrollLeft, false, isMobile),
      behavior: "smooth"
    });
  };

  var onBackward = function onBackward() {
    var _radioListRef$current2;

    (_radioListRef$current2 = radioListRef.current) === null || _radioListRef$current2 === void 0 ? void 0 : _radioListRef$current2.scrollTo({
      left: (0,app_utils_scroll__WEBPACK_IMPORTED_MODULE_11__/* .calculateRadioScroll */ .R$)(radioListRef.current.scrollLeft, true, isMobile),
      behavior: "smooth"
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper), className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().header),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h2", {
        children: label
      }), !arrowNavigationEnabled && !wrapped && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().buttons),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow_back)),
          onClick: function onClick() {
            return onBackward();
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_icons_ArrowRight__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
          className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow),
          onClick: function onClick() {
            return onForward();
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_icons_ArrowRight__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_list),
      ref: radioListRef,
      children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().row),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_station), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_station), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_station), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_station), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_station), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_station), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_station), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().radio_station), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().placeholder_item))
        })]
      }) : itemRows.map(function (row, rowIndex) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_stations_row_component__WEBPACK_IMPORTED_MODULE_5__/* .StationsRow */ .F, {
          items: row,
          scrollSyncId: scrollSyncId,
          handleOnClick: handleOnClick,
          showStationNames: showStationNames,
          navigateStation: showDetailsOnClick,
          wrapped: wrapped,
          fetchNextPage: fetchNextPage,
          triggerFetchNextPage: rowIndex === 0
        }, "radio-stations-row-".concat(rowIndex));
      })
    })]
  });
};

/***/ }),

/***/ 99845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StationsRow; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59499);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var _stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98215);
/* harmony import */ var _stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icons_Logo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23583);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80621);
/* harmony import */ var app_utils_is_mobile_resolution__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26089);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4062);
/* harmony import */ var app_store_slices_radio__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49624);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);













var StationsRow = function StationsRow(_ref) {
  var _clsx;

  var items = _ref.items,
      wrapped = _ref.wrapped,
      showStationNames = _ref.showStationNames,
      handleOnClick = _ref.handleOnClick,
      scrollSyncId = _ref.scrollSyncId,
      navigationDisabled = _ref.navigationDisabled,
      _ref$fetchNextPage = _ref.fetchNextPage,
      fetchNextPage = _ref$fetchNextPage === void 0 ? function () {} : _ref$fetchNextPage,
      triggerFetchNextPage = _ref.triggerFetchNextPage,
      _ref$navigateStation = _ref.navigateStation,
      navigateStation = _ref$navigateStation === void 0 ? false : _ref$navigateStation,
      column = _ref.column;
  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();
  var loadMoreTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var intersection = (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(loadMoreTriggerRef, {
    rootMargin: "0px",
    threshold: 1
  });
  var isMobile = (0,app_utils_is_mobile_resolution__WEBPACK_IMPORTED_MODULE_8__/* .useIsMobileResolution */ .zO)();

  var onLinkClick = function onLinkClick(radioStation) {
    dispatch(app_store_slices_radio__WEBPACK_IMPORTED_MODULE_4__/* .radioActions.selectRadio */ .xF.selectRadio({
      section: items,
      activeIndex: items.indexOf(radioStation)
    }));
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (triggerFetchNextPage && intersection !== null && intersection !== void 0 && intersection.isIntersecting) {
      fetchNextPage();
    }
  }, [intersection, triggerFetchNextPage]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().row), (_clsx = {}, (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_clsx, (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().vertical), column), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_clsx, (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().wrapped), wrapped), _clsx)),
    "data-navigate-row": !navigationDisabled,
    "data-navigate-scrollable": true,
    "data-navigate-scrollable-parent": true,
    "data-sync-scroll-position": scrollSyncId,
    children: [items.map(function (radioStation, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        "data-navigate-row": !navigationDisabled && column,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
          href: "/".concat(radioStation.permalink),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
            "data-navigate-item": !navigationDisabled,
            tabIndex: 0,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().radio_station), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().show_station_names), showStationNames)),
            onClick: function onClick(e) {
              if (navigateStation) {
                onLinkClick(radioStation);
              } else {
                e.preventDefault();
                handleOnClick(radioStation, items.indexOf(radioStation));
              }
            },
            children: [radioStation !== null && radioStation !== void 0 && radioStation.logo || radioStation !== null && radioStation !== void 0 && radioStation.logo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
              className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().cover),
              src: (radioStation === null || radioStation === void 0 ? void 0 : radioStation.logo) || (radioStation === null || radioStation === void 0 ? void 0 : radioStation.logo) || "",
              width: isMobile ? 96 : 156,
              height: isMobile ? 96 : 156,
              layout: "fixed",
              objectFit: "cover",
              alt: radioStation.name,
              unoptimized: true
            }, "radio-station-".concat(index, "-").concat(radioStation.permalink)) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().cover), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().no_image)),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_Logo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
            }), showStationNames && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().station_title),
              children: radioStation.name
            })]
          })
        }, "radio-station-wrap-".concat(index, "-").concat(radioStation.permalink))
      }, "station-row-".concat(index, "-").concat(radioStation.permalink));
    }), triggerFetchNextPage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      ref: loadMoreTriggerRef
    })]
  });
};

/***/ }),

/***/ 91942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ splitToChunks; }
/* harmony export */ });
/* unused harmony export getCircularReplacer */
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

function splitToChunks(array, parts) {
  var arrayCopy = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(array);

  var result = [];

  for (var i = parts; i > 0; i--) {
    result.push(arrayCopy.splice(0, Math.ceil(arrayCopy.length / i)));
  }

  return result;
}
var getCircularReplacer = function getCircularReplacer() {
  var seen = new WeakSet();
  return function (key, value) {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }

      seen.add(value);
    }

    return value;
  };
};

/***/ }),

/***/ 26089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vl": function() { return /* binding */ useIsLargeDesktopResolution; },
  "zO": function() { return /* binding */ useIsMobileResolution; }
});

// UNUSED EXPORTS: useIsSmallDesktopResolution

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(76362);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useMedia.js


var getInitialState = function (query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (util/* isBrowser */.jU) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (false) {}
    return false;
};
var useMedia_useMedia = function (query, defaultState) {
    var _a = (0,react.useState)(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function () {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [query]);
    return state;
};
/* harmony default export */ var esm_useMedia = (useMedia_useMedia);

;// CONCATENATED MODULE: ./app/utils/is-mobile-resolution.ts

var useIsMobileResolution = function useIsMobileResolution() {
  return esm_useMedia('(max-width: 768px)');
};
var useIsSmallDesktopResolution = function useIsSmallDesktopResolution() {
  return useMedia('(max-width: 1281px)');
};
var useIsLargeDesktopResolution = function useIsLargeDesktopResolution() {
  return esm_useMedia('(min-width: 1920px)');
};

/***/ }),

/***/ 21278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HE": function() { return /* binding */ calculateCategoryScroll; },
/* harmony export */   "R$": function() { return /* binding */ calculateRadioScroll; },
/* harmony export */   "_7": function() { return /* binding */ calculatePodcastScroll; },
/* harmony export */   "xF": function() { return /* binding */ calculateCountryListScroll; }
/* harmony export */ });
/* unused harmony export getFontSizeMultiplier */
/* harmony import */ var _components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98215);
/* harmony import */ var _components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_podcats_list_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93646);
/* harmony import */ var _components_podcats_list_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_components_podcats_list_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_category_list_category_list_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52986);
/* harmony import */ var _components_category_list_category_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_category_list_category_list_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_country_list_country_list_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46652);
/* harmony import */ var _components_country_list_country_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_country_list_country_list_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_variables_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80792);
/* harmony import */ var _styles_variables_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var getFontSizeMultiplier = function getFontSizeMultiplier() {
  return window.innerWidth >= 3840 ? 1.6 : window.innerWidth >= 2560 ? 1.12 : 1;
};

var getRadioStationBoxWidth = function getRadioStationBoxWidth() {
  return Number(_components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0___default().radioStationOuterWidth.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getRadioStationBoxWidthMobile = function getRadioStationBoxWidthMobile() {
  return Number(_components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0___default().radioStationOuterWidthMobile.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getPodcastBoxWidth = function getPodcastBoxWidth() {
  return Number(_components_podcats_list_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_1___default().podcastOuterWidth.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getCountryWidth = function getCountryWidth() {
  return Number(_components_country_list_country_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().countryWidth.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getCategoryBoxWidth = function getCategoryBoxWidth() {
  return Number(_components_category_list_category_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryOuterWidth.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getContentMaxWidth = function getContentMaxWidth() {
  return (Number(_styles_variables_module_scss__WEBPACK_IMPORTED_MODULE_4___default().contentMaxWidth.replace('rem', '')) - 4) * 10 * getFontSizeMultiplier();
};

var getPadding = function getPadding() {
  if (window.innerWidth < 421) {
    return 0;
  }

  if (window.innerWidth < 1025) {
    return 32;
  }

  return 50;
};

var getRadioWidth = function getRadioWidth(isMobile) {
  return isMobile ? getRadioStationBoxWidthMobile() : getRadioStationBoxWidth();
};

var calculateRadioScroll = function calculateRadioScroll(scrollLeft) {
  var substract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var radioStationWidth = getRadioWidth(isMobile);
  var windowWidth = window.innerWidth - getPadding();
  var startWidth = substract ? scrollLeft - windowWidth : scrollLeft + windowWidth;
  var radioItemsVisible = startWidth / radioStationWidth;
  return startWidth - (radioItemsVisible - Math.floor(radioItemsVisible)) * radioStationWidth;
};
var calculatePodcastScroll = function calculatePodcastScroll(scrollLeft) {
  var substract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var podcastWidth = getPodcastBoxWidth();
  var scrollWidth = window.innerWidth - getPadding();
  var startWidth = substract ? scrollLeft - scrollWidth : scrollLeft + scrollWidth;
  var podcastItemsVisible = startWidth / podcastWidth;
  return startWidth - (podcastItemsVisible - Math.floor(podcastItemsVisible)) * podcastWidth;
};
var calculateCountryListScroll = function calculateCountryListScroll(scrollLeft) {
  var substract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var countryWidth = getCountryWidth();
  var maxContentWidth = getContentMaxWidth();
  var scrollWidth = window.innerWidth > maxContentWidth ? maxContentWidth : window.innerWidth - getPadding();
  var startWidth = substract ? scrollLeft - scrollWidth : scrollLeft + scrollWidth;
  var countryItemsVisible = startWidth / countryWidth;
  return startWidth - (countryItemsVisible - Math.floor(countryItemsVisible)) * countryWidth;
};
var calculateCategoryScroll = function calculateCategoryScroll(scrollLeft) {
  var substract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var categoryBoxWidth = getCategoryBoxWidth();
  var windowWidth = window.innerWidth - getPadding();
  var startWidth = substract ? scrollLeft - windowWidth : scrollLeft + windowWidth;
  return startWidth - (startWidth / categoryBoxWidth - Math.floor(startWidth / categoryBoxWidth)) * categoryBoxWidth;
};

/***/ }),

/***/ 52986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","categoryOuterWidth":"25.2rem","wrapper":"category-list_wrapper__1oH1M","header":"category-list_header__pSoNI","premium_label":"category-list_premium_label__wvcuk","buttons":"category-list_buttons__1z2bB","arrow":"category-list_arrow__AdMBS","arrow_back":"category-list_arrow_back__RBMtu","category":"category-list_category__vGBTi","category_list":"category-list_category_list__bqOiw","active":"category-list_active__pqekF","category_img":"category-list_category_img__DiU_c","cover_empty":"category-list_cover_empty__qyxqz","cover_wrapper":"category-list_cover_wrapper__m9WBG","cover":"category-list_cover__cK3He","category_details":"category-list_category_details__KPyrY","category_name":"category-list_category_name__4nFwj","placeholder_item":"category-list_placeholder_item__eRRX9","load":"category-list_load__ezJp5"};

/***/ }),

/***/ 46652:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","countryWidth":"16rem","header":"country-list_header__JOh1w","buttons":"country-list_buttons__Car0k","arrow":"country-list_arrow__IPaMq","arrow_back":"country-list_arrow_back__HfSwM","radio_station":"country-list_radio_station__TNr_V","radio_list":"country-list_radio_list__oigaF","cover":"country-list_cover__6mARf","no_image":"country-list_no_image__6v_GD","station_title":"country-list_station_title__oHN5U","show_station_names":"country-list_show_station_names__pTsO4","row":"country-list_row__K_Plb","wrapped":"country-list_wrapped__xWnqS","placeholder_item":"country-list_placeholder_item__LU4OG","load":"country-list_load__OjEMP"};

/***/ }),

/***/ 93646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","podcastOuterWidth":"30rem","podcast":"podcast-list_podcast__8s76E","podcast_img":"podcast-list_podcast_img__tcbGa","placeholder_item":"podcast-list_placeholder_item__aM8sp","header":"podcast-list_header__ii0S7","buttons":"podcast-list_buttons__VFUF0","arrow":"podcast-list_arrow__814ZP","arrow_back":"podcast-list_arrow_back__z2hsB","podcast_list":"podcast-list_podcast_list___Thgh","cover_wrapper":"podcast-list_cover_wrapper__IZfZ7","cover":"podcast-list_cover__GHyYI","no_image":"podcast-list_no_image__lgTwZ","podcast_details":"podcast-list_podcast_details__ZEy0T","podcast_name":"podcast-list_podcast_name__6KtYg","podcast_description":"podcast-list_podcast_description__phzb7","row":"podcast-list_row__0BUuV","load":"podcast-list_load__I13Dy"};

/***/ }),

/***/ 98215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","radioStationOuterWidth":"18.2rem","radioStationOuterWidthMobile":"12.2rem","wrapper":"stations-list_wrapper__EQsZ_","radio_station":"stations-list_radio_station__V7ZFQ","header":"stations-list_header__WR2Ed","placeholder_item":"stations-list_placeholder_item__S5kXd","station_title":"stations-list_station_title__6tidF","buttons":"stations-list_buttons__dgWsZ","arrow":"stations-list_arrow__hsaxX","arrow_back":"stations-list_arrow_back__srxIO","radio_list":"stations-list_radio_list__nB0CT","cover_wrapper":"stations-list_cover_wrapper__LLHG3","cover":"stations-list_cover__OEgIg","no_image":"stations-list_no_image__3biBe","show_station_names":"stations-list_show_station_names__aW01m","row":"stations-list_row__v4ZLU","vertical":"stations-list_vertical__rnn2R","wrapped":"stations-list_wrapped__lUsyl","load":"stations-list_load__gmj9g"};

/***/ }),

/***/ 80792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem"};

/***/ }),

/***/ 80621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIntersection = function (ref, options) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersection);


/***/ })

}]);